<template>
  <div class="main">
    <div class="home shadow">
      <div class="inner-no-access">
        <img src="../../assets/img/no-access.jpg" class="noAccessLogo">
        <span class="noAccessText">为更好地为您提供服务，本网站每日17:00至次日8:00，春节、“十一”等长假期间进行系统维护。您可在每日8:00至17:00进行访问，感谢您的理解。</span>
        <div class="noAccessFoot">
          <el-button type="primary" @click="back('政府信息公开申请')">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    back(name) {
      this.$router.push({
        path: '/',
        query: {
          name: name,
          id: 0
        }
      })
    }
  }
}

</script>
<style scoped>
    .noAccessText{
        font-size:18px;
        font-weight: 600;
        vertical-align: middle;
        display: inline-block;
        line-height: 50px;
    }
    .noAccessFoot{
        margin-top:20px
    }
    .noAccessLogo{
        width:340px;
        height: 300px;
    }
    .inner-no-access{
        padding:26px;
    }
</style>
